__turbopack_context__.v({
  "logoBV": "FeqWJG_logoBV",
});
